import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { deselectFrame, updateWallpaperDim } from "../../actions/project/frame";
import WallBackground from './../../components/WallBackground'

const mapStateToProps = state => ({
  src: dotProp.get(state, 'project.background.src'),
  scale: dotProp.get(state, 'project.background.scale'),
  crop: dotProp.get(state, 'project.background.crop', { x: 0, y: 0, width: 100, height: 100 }),
  isFull: dotProp.get(state, 'sidebar.isClosed', false),
})

const mapDispatchToProps = dispatch => ({
  onClick: () => dispatch(deselectFrame()),
  updateDim: (w, h) => dispatch(updateWallpaperDim(w, h))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WallBackground)



// WEBPACK FOOTER //
// ./src/containers/WallBackground/index.js